import { withTranslation } from "react-i18next";
import React, { PureComponent } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from 'Components/Layout';
class Page404 extends PureComponent {
  render() {
    const { t } = this.props;
    return <Layout>
        <Helmet>
          <title>{t("Page not found - HeresMyInfo.com")}</title>
        </Helmet>
        <Container>
          <Row>
            <Col>
              <h1>{t("Ooops. Page not found")}</h1>
              <p>{t("Would you like to start with")}<Link to='/'>{t("Main page")}</Link>{t("or")}<Link to='learn'>{t("Learn more")}</Link>{t("about HeresMyInfo?")}</p>
            </Col>
          </Row>
        </Container>
      </Layout>;
  }
}
export default withTranslation()(Page404);